import React from 'react';
import '../../styles/pages.css';

export default function Packages() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Packages</h1>
        <p>View available SMS packages and plans</p>
      </div>
      <div className="page-section">
        <p className="text-muted">Packages and pricing plans coming soon.</p>
      </div>
    </div>
  );
}
